import { QueryClient } from "@tanstack/react-query";

import { isApiError } from "@/api/errors";

/** 5xx / ネットワークエラーのリトライ上限。 */
const MAX_RETRIES = 2;

/**
 * アプリ共通の QueryClient。
 *
 * providers 側で `useState(() => createQueryClient())` により一度だけ生成する
 * （レンダ本体で new すると oxlint の @tanstack/query/stable-query-client が error）。
 *
 * 401 のハンドリングは API クライアント（createApiClient の onUnauthorized）に一本化する。
 * ここで重ねると再ログインが二重に走る。
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        // 業務画面でタブ復帰ごとに一覧が動くのを避ける
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          // 4xx はリトライしても結果が変わらない
          if (isApiError(error) && error.status < 500) return false;
          return failureCount < MAX_RETRIES;
        },
      },
      mutations: { retry: 0 },
    },
  });
}
